import iconFieldworkerBike from "~/assets/images/icons/icon_fieldworker_bike.svg";
import iconFieldworkerCar from "~/assets/images/icons/icon_fieldworker_car.svg";
import iconFieldworkerMyWheels from "~/assets/images/icons/icon_fieldworker_mywheels.svg";
import iconFieldworkerPickup from "~/assets/images/icons/icon_fieldworker_pick_up.svg";
import iconChangeCircleOutlined from "~/assets/images/icons/icon_change_circle_outlined.svg";
import markerCircleDashedStroke from "~/assets/images/icons/marker_circle_dashed_stroke.svg";
import { LABEL_CONFIGS } from "~/modules/map/components/GaiaMapStyleComposites/layerConfigs";
import {
    IMG_MARKER_CHANGE_CIRCLE_OUTLINED,
    IMG_MARKER_CIRCLE_DASHED_STROKE,
    IMG_MARKER_FIELDWORKER_BIKE,
    IMG_MARKER_FIELDWORKER_CAR,
    IMG_MARKER_FIELDWORKER_MYWHEELS,
    IMG_MARKER_FIELDWORKER_PICK_UP,
} from "~/modules/map/mapStyles";
import { loadLabelBackgrounds, loadMapIcons } from "~/modules/map/util/imageLoaders";

export async function loadGaiaPlannerV2Images(map: mapboxgl.Map): Promise<void> {
    const icons = [
        { file: iconFieldworkerCar, id: IMG_MARKER_FIELDWORKER_CAR },
        { file: iconFieldworkerMyWheels, id: IMG_MARKER_FIELDWORKER_MYWHEELS },
        { file: iconFieldworkerBike, id: IMG_MARKER_FIELDWORKER_BIKE },
        { file: iconFieldworkerPickup, id: IMG_MARKER_FIELDWORKER_PICK_UP },
        { file: iconChangeCircleOutlined, id: IMG_MARKER_CHANGE_CIRCLE_OUTLINED },
        { file: markerCircleDashedStroke, id: IMG_MARKER_CIRCLE_DASHED_STROKE },
    ];

    await Promise.all([loadMapIcons(map, icons), Promise.resolve(loadLabelBackgrounds(map, LABEL_CONFIGS))]);
}
